import { GridItem } from 'atoms/Grid';
import createComponents from 'libs/notion-renderer/createComponents';
import { NotionProps } from 'notion/types';

const NotionGridItem: React.FC<NotionProps> = ({
  block: { loadedContent },
}) => <GridItem>{createComponents(loadedContent)}</GridItem>;

export default NotionGridItem;
